import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {policyDeutschSx} from './PolicyDeutsch.sx';

export const PolicyDeutsch: FC = () => {
    return (
        <Box>
            <Box sx={policyDeutschSx.root}>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    AMP IT SA
                </Typography>
                <Typography variant="h2">Datenschutzerklärung</Typography>

                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    <em>September 2026</em>
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Die AMP IT SA und die Gesellschaften ihrer Unternehmensgruppe (nachfolgend auch einzeln oder
                    gemeinsam «AMP IT», «wir», «uns» oder «unser») erheben und bearbeiten Personendaten über Sie sowie
                    über andere Personen («Dritte»). Die vorliegende Datenschutzerklärung kann separat ergänzt werden,
                    beispielsweise durch Einwilligungsformulare, Allgemeine Geschäftsbedingungen, zusätzliche
                    Erklärungen und andere Kommunikationsmittel.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wenn Sie uns Daten mitteilen oder mit uns Daten über Dritte teilen, bestätigen Sie, dazu berechtigt
                    zu sein und dass die betreffenden Daten zutreffend sind. Sie werden zudem gebeten, sicherzustellen,
                    dass die Personen, deren Daten geteilt werden, über diese Datenschutzerklärung informiert wurden.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir verpflichten uns, die Sie betreffenden Personendaten verantwortungsvoll zu bearbeiten.
                    Dementsprechend halten wir die Anforderungen des Bundesgesetzes über den Datenschutz (DSG), der
                    Verordnung zum Bundesgesetz über den Datenschutz (VDSG), des Fernmeldegesetzes (FMG) sowie der
                    übrigen Bestimmungen der schweizerischen Datenschutzgesetzgebung ein. In Bezug auf die Bearbeitung
                    von Personendaten betroffener Personen mit Wohnsitz in der Europäischen Union halten wir zudem die
                    Bestimmungen der europäischen Datenschutz-Grundverordnung (DSGVO) ein.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    1. Verantwortliche(r)
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Die AMP IT SA, 1-3 Rue des Sablières, 1242 Satigny, Schweiz, ist eine Gesellschaft schweizerischen
                    Rechts, deren Zweck insbesondere die Installation und Verwaltung von Ladestationen für
                    Elektrofahrzeuge sowie die Erstellung, Entwicklung, den Betrieb und die Verwaltung sämtlicher
                    Software, Plattformen oder IT-Portale jeglicher Form und auf jeglichem Trägermedium im Zusammenhang
                    mit ihren Tätigkeiten umfasst.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Sie ist für die nachfolgend beschriebenen Zwecke die «Verantwortliche», sofern sie Ihnen in einem
                    bestimmten Fall nichts anderes mitteilt, beispielsweise in spezifischen Datenschutzerklärungen, auf
                    einem Formular oder in einem Vertrag. Das bedeutet, dass allein die AMP IT SA dafür verantwortlich
                    ist, wie sie die Sie betreffenden Personendaten aufbewahrt und verwendet.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Sie können uns bei Fragen zum Datenschutz und zur Ausübung Ihrer Rechte gemäss der vorliegenden
                    Datenschutzerklärung über folgende E-Mail-Adresse kontaktieren: <a
                    href="mailto:info@amp-it.ch">info@amp-it.ch</a>
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    2. Umfang und Zweck der Erhebung, Bearbeitung und Nutzung von Personendaten
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    2.1 Erhebung und Bearbeitung von Personendaten
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir erheben Sie betreffende Personendaten insbesondere in folgenden Fällen und zu den nachstehend
                    aufgeführten Zwecken:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • Erstellung eines Kundenkontos<br/>
                    • Kommunikation mit dem Nutzer<br/>
                    • Über das Kontaktformular gestellte Fragen oder im Rahmen des Austauschs für
                    Support-Dienstleistungen (einschliesslich über einen Chatbot)<br/>
                    • In Ihr Nutzerkonto hochgeladene Daten<br/>
                    • Überprüfung Ihrer Identität<br/>
                    • Erstellung von Nutzungsstatistiken<br/>
                    • Marketing und Marktforschung
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Die Zwecke und Ziele der Erhebung von Personendaten dienen insbesondere unseren Interessen und
                    möglicherweise denjenigen Dritter im Rahmen der Erbringung bestimmter Leistungen. Wir bearbeiten
                    Ihre Daten somit zu folgenden Zwecken:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • Kommunikation mit Ihnen, insbesondere zur Beantwortung Ihrer Anfragen und zur Ausübung Ihrer
                    Rechte sowie damit wir Sie bei Fragen kontaktieren können. Zu diesem Zweck verwenden wir
                    insbesondere Kommunikations- und Stammdaten sowie Registrierungsdaten im Zusammenhang mit den von
                    Ihnen genutzten Angeboten und Diensten. Wir können diese Daten zur Dokumentation der Kommunikation
                    mit Ihnen zu Schulungs-, Qualitätssicherungs- und/oder Nachverfolgungszwecken aufbewahren;<br/>
                    • Abschluss, Verwaltung und Erfüllung von Vertragsverhältnissen;<br/>
                    • Marketing und Beziehungsmanagement;<br/>
                    • Marktforschung, zur Verbesserung unserer Dienstleistungen und unserer Geschäftstätigkeiten sowie
                    zur Produktentwicklung;<br/>
                    • Sicherheit und Zugangskontrolle;<br/>
                    • Einhaltung von Gesetzen, Richtlinien und Empfehlungen der Behörden sowie interner Vorschriften
                    («Einhaltung gesetzlicher Anforderungen»);<br/>
                    • unser Risikomanagement und unsere Unternehmensführung, einschliesslich der Organisation und
                    Entwicklung unserer Geschäftstätigkeit.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir können Ihre Daten für weitere Zwecke bearbeiten, beispielsweise im Rahmen unserer internen
                    Prozesse und Verwaltung oder zu Qualitätssicherungs- und Schulungszwecken.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wenn wir für bestimmte Bearbeitungstätigkeiten Ihre Einwilligung einholen (beispielsweise für
                    Marketingaktivitäten, für die Registrierung im Lieferantenportal, für die Verwaltung von Werbung und
                    die Analyse des Verhaltens auf der Website), informieren wir Sie gesondert über die betreffenden
                    Bearbeitungszwecke. Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen,
                    indem Sie uns eine E-Mail an folgende Adresse senden: <a
                    href="mailto:info@amp-it.ch">info@amp-it.ch</a>. Sobald wir die Mitteilung über den Widerruf der
                    Einwilligung erhalten haben, werden wir Ihre Angaben nicht mehr zu dem bzw. den Zwecken bearbeiten,
                    denen Sie zugestimmt hatten, es sei denn, wir verfügen über eine andere Rechtsgrundlage dafür. Der
                    Widerruf der Einwilligung berührt jedoch nicht die Rechtmässigkeit der aufgrund der Einwilligung bis
                    zum Widerruf erfolgten Bearbeitung.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wo wir keine Einwilligung für die Bearbeitung einholen, stützt sich die Bearbeitung Ihrer
                    Personendaten auf die Erforderlichkeit der Bearbeitung zur Anbahnung oder Erfüllung eines Vertrags
                    mit Ihnen (oder der von Ihnen vertretenen Einheit) oder auf unser berechtigtes Interesse bzw.
                    dasjenige eines Dritten an der betreffenden Bearbeitung, insbesondere zur Verfolgung der in dieser
                    Datenschutzerklärung genannten Zwecke und Ziele sowie zur Umsetzung entsprechender Massnahmen. Zu
                    unseren berechtigten Interessen zählt auch die Einhaltung gesetzlicher Vorschriften, soweit diese
                    nicht bereits nach dem anwendbaren Datenschutzrecht als Rechtsgrundlage anerkannt ist
                    (beispielsweise im Fall der DSGVO die Gesetze im EWR und im Fall des DSG das schweizerische Recht).
                    Dazu gehören auch die Vermarktung unserer Dienstleistungen, das Bestreben, unsere Märkte besser zu
                    verstehen sowie unser Unternehmen einschliesslich seiner Tätigkeiten sicher und effizient zu führen
                    und weiterzuentwickeln.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    2.2 Weitergabe von Daten
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Im Rahmen unserer Verträge, der Nutzung der Website, unserer Dienstleistungen, unserer gesetzlichen
                    Verpflichtungen, des Schutzes unserer berechtigten Interessen sowie der übrigen vorstehend genannten
                    Zwecke können wir Ihre Personendaten an Dritte weitergeben, insbesondere an folgende Kategorien von
                    Empfängern:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • Dienstleister: Wir arbeiten mit Dienstleistern in der Schweiz und im Ausland zusammen, die Ihre
                    Daten in unserem Auftrag oder als gemeinsam mit uns Verantwortliche bearbeiten oder die von uns
                    Daten über Sie als eigenständig Verantwortliche erhalten (beispielsweise IT-Dienstleister, Anbieter
                    von Werbedienstleistungen, IT-Sicherheitsunternehmen, Banken, Versicherungsgesellschaften,
                    Inkassounternehmen, Kreditauskunfteien oder Anbieter zur Überprüfung von Adresse, Identität und/oder
                    Unterschrift).<br/>
                    • Vertragspartner, einschliesslich Kunden: Hierbei handelt es sich um Kunden (beispielsweise
                    Leistungsempfänger) sowie unsere übrigen Vertragspartner, soweit sich die Weitergabe der Daten aus
                    diesen Verträgen ergibt. Sie erhalten beispielsweise Registrierungsdaten im Zusammenhang mit der
                    Erbringung von Produkten und Dienstleistungen usw. Falls Sie für einen dieser Vertragspartner tätig
                    sind, können wir diesem auch Sie betreffende Daten mitteilen. Zu diesen Empfängern zählen auch
                    Vertragspartner, mit denen wir zusammenarbeiten oder die für uns oder andere Dienstleistungen in
                    unserem Namen werben und denen wir daher Sie betreffende Daten zu Analyse-, Beschaffungs- und
                    Marketingzwecken mitteilen können.<br/>
                    • Behörden: Wir können Personendaten an Behörden, Gerichte, Schiedsgerichte und andere Stellen in
                    der Schweiz und im Ausland weitergeben, wenn wir gesetzlich dazu verpflichtet oder berechtigt sind
                    oder wenn dies zum Schutz unserer Interessen erforderlich erscheint. Diese Behörden handeln als
                    eigenständig Verantwortliche.<br/>
                    • Andere Personen: Hierbei handelt es sich um weitere Fälle, in denen Interaktionen mit Dritten im
                    Rahmen der vorstehend genannten Zwecke erfolgen, beispielsweise Leistungsempfänger, Medien und
                    Verbände, an denen wir beteiligt sind, oder wenn Sie in einer unserer Publikationen erscheinen.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Darüber hinaus erlauben wir bestimmten Dritten, Ihre Personendaten auf unserer Website und bei von
                    uns organisierten Veranstaltungen zu erheben (beispielsweise Anbieter von Tools auf unserer Website
                    usw.). Soweit wir keine Kontrolle über diese Datenerhebungen haben, handeln diese Dritten als
                    eigenständig Verantwortliche. Falls Sie Fragen haben oder Ihre Datenschutzrechte ausüben möchten,
                    bitten wir Sie, sich direkt an diese Dritten zu wenden.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    2.2.1 Besuch der Website
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wenn Sie unsere Website besuchen, speichern unsere Server vorübergehend die folgenden Daten in einer
                    sogenannten Server-Logdatei. Diese Daten werden gelöscht, sobald sie für den Zweck ihrer Erhebung
                    nicht mehr erforderlich sind:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • IP-Adresse des anfragenden Computers<br/>
                    • Datum und Uhrzeit des Zugriffs bzw. Abrufs<br/>
                    • URL der abgerufenen Daten<br/>
                    • Betriebssystem, Computermodell und verwendeter Browsertyp<br/>
                    • Land, von dem aus Sie auf unsere Website zugreifen<br/>
                    • Name Ihres Internetanbieters<br/>
                    • Zeitunterschied zur Greenwich Mean Time (GMT)<br/>
                    • Zugriffsstatus, HTTP-Statuscode<br/>
                    • Menge der übertragenen Daten<br/>
                    • Zuletzt besuchte Website<br/>
                    • Browsereinstellungen<br/>
                    • Sprache und Version Ihrer Browser-Software
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Rechtsgrundlage für die vorübergehende Speicherung von Personendaten und Logdateien ist das
                    berechtigte Interesse sowie die Erfüllung eines Vertragsverhältnisses. Es liegt in unserem
                    berechtigten Interesse,
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • die Inhalte unserer Website korrekt darzustellen,<br/>
                    • die Inhalte unserer Website zu optimieren und zu bewerben,<br/>
                    • den Behörden die zur Strafverfolgung im Falle eines Cyberangriffs erforderlichen Informationen zur
                    Verfügung zu stellen,<br/>
                    • unser Angebot und unsere Website laufend zu verbessern,<br/>
                    • statistische Daten zu erheben.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir verwenden die Sie betreffenden Daten hauptsächlich, um Ihre Erfahrung als Kunde zu verbessern
                    und nutzerfreundlicher zu gestalten, um mit Ihnen bezüglich Ihrer Fragen oder Anliegen zu
                    kommunizieren, um Ihnen Informationen zu bestimmten Dienstleistungen oder Marketingkampagnen
                    bereitzustellen und um Ihnen Produkte oder Dienstleistungen zu empfehlen, die für Sie von Interesse
                    sein könnten.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    2.2.2 Newsletter
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Sie können sich für unseren Newsletter anmelden. Um ihn zu erhalten, müssen Sie ein Konto auf
                    unserer Website oder unserer Anwendung erstellt haben. Ihre Einwilligung bildet die Rechtsgrundlage
                    für die Datenbearbeitung, sobald Sie sich für den Newsletter angemeldet haben. Indem Sie uns die Sie
                    betreffenden Daten mitteilen, ermächtigen Sie uns, den Newsletter zu nutzen, um Ihnen Informationen
                    beispielsweise zu Dienstleistungen, Aktionen, Veranstaltungen und Neuigkeiten zu senden.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Darüber hinaus werden bei der Anmeldung folgende Daten erhoben:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • IP-Adresse des anfragenden Computers<br/>
                    • Datum und Uhrzeit der Anmeldung<br/>
                    • Herkunft der Anmeldung (z. B. Website, Warteliste)
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Diese Daten sind für den Versand der Newsletter erforderlich und werden auf der Grundlage Ihrer
                    Einwilligung bearbeitet. Sie können sich jederzeit vom Newsletter abmelden und Ihre Einwilligung
                    widerrufen. In jedem Newsletter finden Sie zudem einen Link zur Abmeldeseite. Wir bewahren die Sie
                    betreffenden Daten auf, bis Sie sich vom Newsletter abmelden.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    2.2.3 Angebotene Dienstleistungen
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    2.2.3.1 Allgemeines
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wenn Sie unsere Dienstleistungen nutzen möchten, ist es unerlässlich, dass Sie uns die für die
                    Bearbeitung Ihrer Anfrage erforderlichen Daten mitteilen.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir bewahren die Sie betreffenden Daten im Rahmen unserer vertraglichen Verpflichtungen auf und
                    löschen sie, sobald wir gesetzlich nicht mehr zu deren Aufbewahrung verpflichtet sind. Im Rahmen der
                    Bearbeitung Ihres Dossiers werden den von uns beauftragten Dienstleistern (wie Banken,
                    IT-Unternehmen und Zahlungsdienstleistern) die für diese Bearbeitung erforderlichen Daten
                    mitgeteilt. Diese Daten können insbesondere Ihre E-Mail-Adresse und Telefonnummer umfassen, wodurch
                    wir Sie beispielsweise kontaktieren können, um allfällige Probleme zu lösen.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    2.2.3.2 Erstellung eines Nutzerkontos
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Durch die Erstellung Ihres Kundenkontos, dessen Zugang durch ein Passwort gesichert ist, können Sie
                    die von Ihnen gespeicherten Informationen und Daten einsehen.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Zur Erstellung eines Kundenkontos können je nach Fall insbesondere folgende Angaben erhoben werden:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • E-Mail-Adresse<br/>
                    • Passwort<br/>
                    • Anrede<br/>
                    • Vorname<br/>
                    • Nachname<br/>
                    • Telefonnummer<br/>
                    • Wohnadresse<br/>
                    • Parkplatzadresse
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Löscht ein Nutzer sein Konto, können die mit diesem Konto verbundenen Daten gelöscht werden,
                    vorbehaltlich der gesetzlich vorgeschriebenen Aufbewahrungspflichten. Wenn Sie sich entscheiden, Ihr
                    Konto zu löschen, obliegt es Ihnen, zuvor eine Sicherungskopie der Sie betreffenden Daten
                    anzufertigen. Wir sind berechtigt, sämtliche während der Aktivitätsdauer des Nutzerkontos
                    gespeicherten Daten unwiderruflich zu löschen.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    2.2.3.3 Virtueller Assistent (Chatbot) und künstliche Intelligenz
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    AMP IT stellt ihren Nutzern einen auf künstlicher Intelligenz basierenden virtuellen Assistenten zur
                    Verfügung, um Support-Anfragen zu ihren Dienstleistungen zu beantworten. Der Assistent weist zu
                    Beginn jedes Gesprächs darauf hin, dass es sich um ein automatisiertes System handelt, und Sie
                    können jederzeit verlangen, an einen Mitarbeitenden weitergeleitet zu werden. Die Nutzung des
                    Assistenten ist nicht verpflichtend.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Auf Ihre Anfrage hin kann der Assistent auch bestimmte Vorgänge in Ihrem Konto ausführen, wie die
                    Verwaltung von Ladeplänen oder das Senden von Befehlen an eine Ladestation. Diese Vorgänge werden
                    niemals automatisch ausgeführt: Sie werden Ihnen vorgeschlagen und nur nach Ihrer ausdrücklichen
                    Bestätigung im Rahmen Ihrer Zugriffsrechte ausgeführt. Die in diesem Rahmen bearbeiteten Daten sind
                    die von Ihnen während des Gesprächs mitgeteilten Daten sowie, je nach Ihren Zugriffsrechten,
                    bestimmte technische Daten, die zur Bearbeitung Ihrer Anfrage erforderlich sind. Sie werden
                    verwendet, um den angefragten Support zu leisten, diesen nachzuverfolgen und dessen Qualität zu
                    kontrollieren.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Der Assistent basiert auf einem von Anthropic bereitgestellten Modell der künstlichen Intelligenz
                    (Vertragspartnerin für die Schweiz und die Europäische Union: Anthropic Ireland, Limited), das
                    mittels der Infrastruktur von Amazon Web Services betrieben wird. Die Anfragen werden in
                    Rechenzentren in der Schweiz und der Europäischen Union bearbeitet, unter Ausschluss jeglicher
                    Weiterleitung in Regionen ausserhalb dieses Gebiets. Jeder Nutzer wird eingeladen, die Informationen
                    und Datenschutzerklärungen zu den von Amazon Web Services angebotenen Dienstleistungen (siehe
                    insbesondere <a
                    href="https://aws.amazon.com/compliance/gdpr-center/">https://aws.amazon.com/compliance/gdpr-center/</a>)
                    sowie von Anthropic Ireland, Limited (siehe insbesondere <a
                    href="https://www.anthropic.com/legal/privacy">https://www.anthropic.com/legal/privacy</a>)
                    einzusehen. Die Gespräche werden in den eigenen Datenbanken von AMP IT gespeichert und sind weder
                    für Amazon Web Services noch für Anthropic zugänglich, vorbehaltlich anwendbarer Ausnahmen. Sie
                    werden nicht zum Trainieren von Modellen der künstlichen Intelligenz verwendet. Sie werden für die
                    zur Erreichung der vorstehend beschriebenen Zwecke erforderliche Dauer aufbewahrt, und Sie können
                    Ihre Gespräche jederzeit über Ihr Konto löschen.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    3. Löschung
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir bearbeiten und speichern die Sie betreffenden Personendaten nur so lange, wie dies zur
                    Erreichung des Zwecks der Erhebung erforderlich ist, oder gemäss den Rechts- oder
                    Verwaltungsvorschriften, denen wir unterliegen. Sobald der Zweck der Speicherung entfällt oder eine
                    vorgeschriebene Aufbewahrungsfrist abläuft, werden Personendaten in der Regel gesperrt oder
                    gelöscht. Wir löschen die Sie betreffenden Daten zudem, wenn Sie dies durch eine E-Mail an folgende
                    Adresse beantragen: <a href="mailto:info@amp-it.ch">info@amp-it.ch</a>, sofern uns keine gesetzliche
                    oder andere Verpflichtung zur Aufbewahrung oder Speicherung dieser Daten bindet.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Bei Löschung der freiwillig in Ihrem persönlichen Konto gespeicherten Personendaten verbleiben nach
                    der Löschung der Personendaten nur noch anonymisierte Daten gespeichert.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    4. Weitergabe an Dritte
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    4.1 Grundsätze
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir übermitteln die Sie betreffenden Daten nur, wenn Sie ausdrücklich eingewilligt haben, wenn das
                    Gesetz dies verlangt oder wenn diese Weitergabe sich aus der Nutzung unserer Dienstleistungen, der
                    Beantwortung von Fragen, der Bearbeitung von Anfragen oder allfälliger von Ihnen angeforderter
                    Dienstleistungen ergibt.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Nicht alle Empfänger befinden sich in der Schweiz. Ihre Daten können daher sowohl in Europa als auch
                    grundsätzlich in jedem Land der Welt bearbeitet werden. Befindet sich ein Empfänger in einem Land
                    ohne angemessenen gesetzlichen Datenschutz, verlangen wir von diesem Empfänger die Zusicherung, die
                    anwendbare Datenschutzgesetzgebung einzuhalten, es sei denn, der Empfänger unterliegt bereits einem
                    rechtlich anerkannten Regelwerk zur Gewährleistung des Datenschutzes oder wir können uns auf eine
                    Ausnahme berufen. Eine Ausnahme gilt beispielsweise im Falle eines ausländischen Gerichtsverfahrens,
                    im Falle eines überwiegenden öffentlichen Interesses oder wenn die Erfüllung eines Vertrags die
                    Übermittlung von Daten erfordert, ebenso wenn Sie der Datenübermittlung zugestimmt haben oder die
                    Daten von Ihnen direkt allgemein zugänglich gemacht wurden und Sie der Bearbeitung nicht
                    widersprochen haben. Bitte beachten Sie, dass über das Internet ausgetauschte Daten häufig durch
                    Drittstaaten geleitet werden. Ihre Daten können daher auch dann ins Ausland gesendet werden, wenn
                    sich Absender und Empfänger im selben Land befinden.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir geben Ihre Personendaten an folgende Kategorien von Empfängern weiter:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • Dienstleister<br/>
                    • Geschäftspartner<br/>
                    • Partnerunternehmen zur Identitätsüberprüfung<br/>
                    • Logistikpartner<br/>
                    • Hosting-Partner<br/>
                    • Behörden und Sozialversicherungsträger (unabhängig davon, ob es sich um öffentliche oder private
                    Einrichtungen handelt)
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wenn wir Subunternehmer zur Erbringung unserer Dienstleistungen einsetzen, verpflichten wir uns,
                    sämtliche gesetzlich vorgeschriebenen Vorkehrungen sowie die entsprechenden technischen und
                    organisatorischen Sicherheitsmassnahmen zu treffen, um sicherzustellen, dass die Sie betreffenden
                    Personendaten in Übereinstimmung mit den einschlägigen regulatorischen Bestimmungen geschützt
                    werden.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    4.2 Persönliches Konto
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Sie werden darüber informiert, dass die von Ihnen freiwillig in Ihrem persönlichen Konto
                    gespeicherten Daten bei AWS gehostet werden. Wenn Sie weitere Informationen zur Datenspeicherung bei
                    AWS und dessen Datenschutzerklärung wünschen, konsultieren Sie bitte folgenden Link: <a
                    href="https://aws.amazon.com/compliance/data-protection/">https://aws.amazon.com/compliance/data-protection/</a>
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    4.3 Nutzung spezifischer Dienstleistungen
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    AMP IT setzt bestimmte Dienstleister/Anwendungen im Rahmen der Automatisierung ihrer Prozesse und
                    der Verwaltung von Nutzerkonten ein. Sie werden darüber informiert, dass Personendaten mit diesen
                    Dienstleistern zur Erbringung der Dienstleistungen von AMP IT zu Ihren Gunsten geteilt werden
                    können. Sie können jederzeit weitere Informationen zu diesen spezifischen Dienstleistungen bei AMP
                    IT anfordern und die Datenschutzerklärungen der Dienstleister einsehen.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Zum jetzigen Zeitpunkt umfassen diese Dienstleister: Amazon Web Services (Hosting und
                    Infrastruktur), Anthropic (Modell der künstlichen Intelligenz des virtuellen Assistenten), Stripe
                    (Zahlungsabwicklung), Bexio (Buchhaltung und Rechnungsstellung), Freshsales
                    (Kundenbeziehungsmanagement) und Google (Reichweitenmessung der Website sowie Firebase-Dienste der
                    mobilen Anwendung: Push-Benachrichtigungen, Nutzungsstatistiken und Absturzberichte). Der Einsatz
                    dieser Dienstleister beschränkt sich auf das für die Erbringung der betreffenden Dienstleistungen
                    Erforderliche. Sie werden gebeten, deren Datenschutzerklärungen einzusehen.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    5. Analytische Daten
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Auf der Grundlage Ihrer Einwilligung und mittels Cookie-Technologie werden Daten erhoben, um unsere
                    Dienstleistungen und die Nutzererfahrung zu optimieren. Diese Daten sind analytischer Natur und
                    dienen nicht Ihrer persönlichen Identifizierung, sondern ausschliesslich einer pseudonymisierten
                    Auswertung der Nutzung der Dienstleistungen. Die Sie betreffenden Daten werden niemals mit den von
                    uns aufbewahrten Personendaten zusammengeführt.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    6. Cookies
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    6.1 Was sind Cookies?
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Unsere Website verwendet sogenannte Cookies. Cookies sind Informationen, die von unserem Webserver
                    oder von Webservern Dritter an die Webbrowser der Nutzer übermittelt werden. Diese werden dann in
                    diesen Browsern gespeichert, bevor sie später abgerufen werden. Sie können die Form kleiner Dateien
                    oder anderer Informationsspeichermedien annehmen.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    6.2 Warum verwenden wir Cookies?
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Cookies dienen dazu, die auf unserer Website angezeigten Informationen und Angebote zu optimieren,
                    um Ihre Erfahrung zu verbessern. Sie ermöglichen es uns, Besucher unserer Website wiederzuerkennen.
                    Durch diese Wiedererkennung wird Ihnen die Nutzung unserer Website erleichtert. Für den Betrieb der
                    Website unbedingt erforderliche Cookies werden auf der Grundlage unseres berechtigten Interesses
                    gesetzt. Die in Ziffer 7 beschriebenen Reichweitenmessungs-Cookies werden nur mit Ihrer Einwilligung
                    gesetzt.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    6.3 Welche Cookies verwenden wir?
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Die Website verwendet folgende Cookies:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • Sitzungscookies<br/>
                    • Dauerhafte Cookies<br/>
                    • Anonyme Cookies<br/>
                    • Präferenz-Cookies<br/>
                    • Performance-Cookies<br/>
                    • Cookies Dritter
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Temporäre Cookies werden automatisch gelöscht, sobald Sie Ihren Browser schliessen. Dazu zählen
                    insbesondere die Sitzungscookies. Diese speichern eine sogenannte Sitzungskennung, mit deren Hilfe
                    verschiedene Anfragen Ihres Browsers der entsprechenden Sitzung zugeordnet werden können. Sie
                    ermöglichen es, Ihren Computer bei Ihrer Rückkehr auf die Website wiederzuerkennen. Wir verwenden
                    diese Art von Cookies, um das ordnungsgemässe Funktionieren unserer Website sicherzustellen.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Dauerhafte Cookies hingegen bleiben auch nach Ende der Sitzung auf Ihrer Festplatte gespeichert.
                    Diese Cookies ermöglichen es uns insbesondere, unser Angebot nutzerfreundlicher zu gestalten,
                    beispielsweise indem sie Ihre Anzeigepräferenzen speichern.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Anonyme Cookies, wie statistische Cookies, übermitteln uns keine Personendaten. Sie erheben und
                    liefern Informationen anonym zurück und ermöglichen es uns zu verstehen, wie Besucher mit den
                    Webseiten interagieren. Präferenz-Cookies speichern beispielsweise Verhaltens- oder
                    Anzeigeeinstellungen einer Webseite, Ihre bevorzugte Sprache oder die Region, in der Sie sich
                    befinden.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Performance-Cookies dienen dazu, Informationen darüber zu sammeln, wie Sie unsere Dienstleistungen
                    nutzen, wodurch wir diese verbessern können. Wir verwenden sie beispielsweise, um festzustellen, ob
                    Sie eine bestimmte Seite aufgerufen haben.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    6.4 Verwaltung und Ablehnung von Cookies
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Bei Ihrem ersten Besuch können Sie über ein Banner die Cookies akzeptieren oder ablehnen, die für
                    den Betrieb der Website nicht unbedingt erforderlich sind. Solange Sie Ihre Zustimmung nicht erteilt
                    haben, wird kein Reichweitenmessungs-Cookie gesetzt und es werden keine entsprechenden Daten
                    übermittelt. Sie können Ihre Wahl jederzeit mit Wirkung für die Zukunft über dieses Banner ändern
                    oder widerrufen oder indem Sie die von Ihrem Browser gespeicherten Cookies und Website-Daten
                    löschen.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Es ist nicht zwingend erforderlich, Cookies zu akzeptieren, um unsere Website zu besuchen. Die
                    meisten Browser akzeptieren Cookies automatisch. Wenn Sie diese nicht zulassen möchten, können Sie
                    Ihren Browser so einstellen, dass die verschiedenen Cookie-Einstellungsoptionen angezeigt werden und
                    Sie nur in bestimmten Fällen zustimmen. Sie können ihn auch so einstellen, dass keine Cookies auf
                    Ihrem Computer gespeichert werden oder dass Sie jedes Mal, wenn ein neues Cookie erstellt wird, eine
                    Benachrichtigung erhalten. Einige Browser erlauben beispielsweise Cookies der besuchten Website,
                    blockieren jedoch Cookies Dritter.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Darüber hinaus können bereits auf Ihrem Gerät installierte Cookies jederzeit über Ihren Browser oder
                    andere Computerprogramme gelöscht werden. Alle gängigen Webbrowser bieten diese Option. Sie können
                    Ihren Browser so einstellen, dass er dauerhaft alle Cookies ablehnt.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    7. Web-Analyse-Tools
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    7.1 Grundsätze
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Unsere Website verwendet Google Analytics, dessen Modalitäten nachfolgend beschrieben werden. Dieses
                    Tool wird erst nach Ihrer Einwilligung aktiviert.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    7.2 Google Analytics
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Auf der Grundlage Ihrer Einwilligung nutzen wir Google Analytics 4, einen Reichweitenmessungsdienst,
                    der für Nutzer in der Schweiz und im Europäischen Wirtschaftsraum von Google Ireland Limited, Gordon
                    House, Barrow Street, Dublin 4, Irland («Google»), bereitgestellt wird. Es wird kein
                    Reichweitenmessungs-Cookie gesetzt und keine Daten an Google übermittelt, bevor Sie die
                    entsprechenden Cookies akzeptiert haben; hierzu nutzen wir den Einwilligungsverwaltungsmechanismus
                    von Google (Consent Mode v2), dessen Standardeinstellungen die Reichweitenmessung und Werbung
                    ablehnen. Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie
                    Ihre Wahl im Cookie-Banner unserer Website ändern oder die von Ihrem Browser gespeicherten Cookies
                    und Website-Daten löschen (Ziffer 6.4).
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Google verwendet Cookies. Google bearbeitet die so erhobenen Informationen in unserem Auftrag, um
                    Ihre Nutzung unseres Online-Angebots auszuwerten, Berichte über die damit verbundenen Aktivitäten
                    zusammenzustellen und uns weitere damit verbundene Dienste zur Verfügung zu stellen. In diesem
                    Zusammenhang können aus den bearbeiteten Daten pseudonyme Nutzerprofile erstellt werden. Diese
                    Nutzerprofile werden nach Ablauf der in unserer Google-Analytics-Property konfigurierten
                    Aufbewahrungsdauer, die höchstens vierzehn Monate beträgt, automatisch gelöscht.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Google Analytics 4 speichert und bewahrt keine IP-Adressen. Für den Datenverkehr aus der Schweiz,
                    dem Europäischen Wirtschaftsraum und dem Vereinigten Königreich erfolgt die Geolokalisierung auf
                    Servern in diesen Regionen, wobei die IP-Adresse vor jeder Speicherung gelöscht wird; es werden
                    lediglich ungefähre Geolokalisierungsdaten (Land, Region, Stadt) daraus abgeleitet. Die vom Browser
                    des Nutzers übermittelte IP-Adresse wird mit keinen anderen von Google bereitgestellten Daten
                    zusammengeführt.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Bestimmte Daten können an Google LLC in den Vereinigten Staaten übermittelt werden, wo sie
                    gespeichert werden. Diese Übermittlungen stützen sich auf den Angemessenheitsbeschluss des
                    Bundesrates zum Swiss-U.S. Data Privacy Framework, der seit dem 15. September 2024 in Kraft ist,
                    sowie für betroffene Personen in der Europäischen Union auf den Angemessenheitsbeschluss der
                    Europäischen Kommission vom 10. Juli 2023 zum EU-U.S. Data Privacy Framework, wobei Google LLC im
                    Rahmen dieser Regelwerke zertifiziert ist. Subsidiär stützen sich diese Übermittlungen auf die
                    Standardvertragsklauseln der Europäischen Kommission.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Sie können darüber hinaus die Erhebung der durch Cookies erzeugten und mit Ihrer Nutzung unseres
                    Online-Angebots verbundenen Daten sowie deren Bearbeitung durch Google blockieren, indem Sie auf den
                    nachstehenden Link klicken. Laden Sie die Erweiterung herunter und installieren Sie sie in Ihrem
                    Browser: <a
                    href="http://tools.google.com/dlpage/gaoptout?hl=en">http://tools.google.com/dlpage/gaoptout?hl=en</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Um mehr darüber zu erfahren, wie Google Ihre Daten verwendet, sowie über die verfügbaren
                    Einstellungen, konsultieren Sie bitte folgende Google-Websites:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • <a
                    href="https://www.google.com/intl/de/policies/privacy/partners">https://www.google.com/intl/de/policies/privacy/partners</a> (Datenbearbeitung
                    durch Google bei der Nutzung von Websites oder unseren Anwendungspartnern),<br/>
                    • <a
                    href="http://www.google.com/policies/technologies/ads">http://www.google.com/policies/technologies/ads</a> (Verwendung
                    von Daten zu Werbezwecken),<br/>
                    • <a href="http://www.google.com/settings/ads">http://www.google.com/settings/ads</a> (Verwaltung
                    der Informationen, die Google zur Anzeige von Werbung für Sie verwendet).
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    8. Ihre Rechte
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Ihnen stehen folgende Rechte in Bezug auf die Sie betreffenden Daten zu: Zugang zu Informationen
                    über gespeicherte Daten, Berichtigung, Löschung, Einschränkung, Übertragung, Widerspruch und
                    Widerruf. Wenn Sie der Ansicht sind, dass die Bearbeitung der Sie betreffenden Daten gegen die
                    Datenschutzgesetzgebung verstösst oder dass Ihre diesbezüglichen Rechte nicht eingehalten wurden,
                    können Sie sich mit einer Beschwerde an die Aufsichtsbehörde wenden. Befinden Sie sich im EWR oder
                    in der Schweiz, haben Sie zudem das Recht, eine Beschwerde bei der zuständigen
                    Datenschutz-Aufsichtsbehörde Ihres Landes einzureichen. Eine Liste der Behörden im EWR finden Sie
                    hier: <a
                    href="https://edpb.europa.eu/about-edpb/board/members_en">https://edpb.europa.eu/about-edpb/board/members_en</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Die schweizerische Aufsichtsbehörde erreichen Sie unter folgender Adresse: <a
                    href="https://www.edoeb.admin.ch/edoeb/de/home/der-edoeb/kontakt.html">https://www.edoeb.admin.ch/edoeb/de/home/der-edoeb/kontakt.html</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Die anwendbaren Datenschutzgesetze geben Ihnen das Recht, der Bearbeitung Ihrer Daten unter
                    bestimmten Umständen zu widersprechen, insbesondere der Bearbeitung zu Zwecken der Direktwerbung,
                    dem Profiling zu Zwecken der Direktwerbung sowie anderen berechtigten Interessen an der Bearbeitung.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Um Ihnen die Kontrolle über die Bearbeitung Ihrer Personendaten zu erleichtern, stehen Ihnen in
                    Bezug auf unsere Bearbeitung Ihrer Daten gemäss dem anwendbaren Datenschutzrecht folgende Rechte zu:
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    • Das Recht, von uns Auskunft darüber zu verlangen, ob wir Sie betreffende Daten bearbeiten und
                    gegebenenfalls welche;<br/>
                    • Das Recht, die Berichtigung Ihrer Daten zu verlangen, wenn diese unrichtig sind;<br/>
                    • Das Recht, die Löschung der Daten zu verlangen;<br/>
                    • Das Recht, zu verlangen, dass wir bestimmte Personendaten in einem gängigen elektronischen Format
                    bereitstellen oder sie an einen anderen Verantwortlichen übertragen;<br/>
                    • Das Recht, Ihre Einwilligung zu widerrufen, sofern unsere Bearbeitung auf Ihrer Einwilligung
                    beruht;<br/>
                    • Das Recht, auf Anfrage weitere für die Ausübung dieser Rechte nützliche Informationen zu erhalten.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wenn Sie die vorstehend genannten Rechte uns gegenüber ausüben möchten, können Sie uns schriftlich
                    an unsere Adresse oder, sofern nicht anders angegeben oder vereinbart, per E-Mail kontaktieren. Um
                    Missbrauch vorzubeugen, müssen wir Sie identifizieren (beispielsweise anhand einer Kopie Ihres
                    Personalausweises, sofern eine Identifizierung nicht anderweitig möglich ist).
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Diese Rechte stehen Ihnen auch gegenüber anderen Parteien zu, die als eigenständig Verantwortliche
                    mit uns zusammenarbeiten – Sie können sich direkt an diese wenden, wenn Sie Ihre Rechte im
                    Zusammenhang mit deren Bearbeitung Ihrer Daten ausüben möchten. Informationen zu unseren wichtigsten
                    Partnern und Dienstleistern finden Sie weiter oben.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Bitte beachten Sie, dass bei der Ausübung dieser Rechte gemäss dem anwendbaren Datenschutzrecht
                    Bedingungen, Ausnahmen und Einschränkungen gelten können (beispielsweise zum Schutz Dritter oder von
                    Geschäftsgeheimnissen). Gegebenenfalls werden wir Sie darüber informieren.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Für Fragen, Anregungen oder Anfragen wenden Sie sich bitte an: <a
                    href="mailto:info@amp-it.ch">info@amp-it.ch</a>.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Bitte beachten Sie, dass das Gesetz vorschreibt, bestimmte Daten für einen bestimmten Zeitraum
                    aufzubewahren. Wir sind daher verpflichtet, diese Daten bis zum Ablauf dieser Frist aufzubewahren.
                    Wir sperren diese Daten in unseren IT-Systemen und verwenden sie ausschliesslich zur Erfüllung der
                    gesetzlichen Anforderungen.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    9. Nutzung der Website durch Minderjährige
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Die angebotenen Dienstleistungen richten sich an ein erwachsenes Publikum. Es ist Minderjährigen
                    untersagt, uns Informationen mitzuteilen, die ihre Identifizierung ermöglichen, oder sich
                    anzumelden, um unsere Dienstleistungen zu nutzen. Stellen wir das Vorhandensein solcher
                    Informationen in unseren Datenbanken fest, löschen wir diese umgehend. Der Vater, die Mutter oder
                    der/die gesetzliche Vertreter/in des Kindes ist berechtigt, sich an uns zu wenden, um die Löschung
                    der Daten oder des erstellten Nutzerkontos zu verlangen. In diesem Fall muss die antragstellende
                    Person uns einen offiziellen Nachweis ihres Status als Elternteil oder gesetzliche/r Vertreter/in
                    vorlegen.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    10. Datensicherheit
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir treffen alle erforderlichen technischen und organisatorischen Vorkehrungen, um die Sie
                    betreffenden Personendaten vor Fälschung, Verlust, Zerstörung oder Zugriff durch unbefugte Personen
                    zu schützen, um Ihre Rechte zu gewährleisten und die geltende Datenschutzgesetzgebung einzuhalten.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Die getroffenen Massnahmen zielen darauf ab, die Vertraulichkeit und Integrität der Sie betreffenden
                    Daten sowie die langfristige Verfügbarkeit und Stabilität unserer Systeme und Dienste im Rahmen der
                    Bearbeitung dieser Daten sicherzustellen. Sie gewährleisten zudem die rasche Wiederherstellung der
                    Verfügbarkeit und des Zugangs zu Daten im Falle eines physischen oder technischen Vorfalls. Unsere
                    Massnahmen zur Datenbearbeitung und -sicherheit werden entsprechend dem technologischen Fortschritt
                    laufend verbessert.
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    Wir nehmen auch den Schutz der vertraulichen Daten unseres eigenen Unternehmens sehr ernst. Unsere
                    Mitarbeitenden sowie die von uns beauftragten Dienstleister unterliegen einer
                    Vertraulichkeitspflicht und sind verpflichtet, die Datenschutzvorschriften einzuhalten. Sie haben
                    zudem nur insoweit Zugang zu Personendaten, als dies für ihre Tätigkeit erforderlich ist.
                </Typography>

                <Typography
                    variant="h6"
                    sx={policyDeutschSx.paragraph}
                >
                    11. Änderungen der Datenschutzerklärung
                </Typography>
                <Typography
                    variant="body2"
                    sx={policyDeutschSx.paragraph}
                >
                    AMP IT kann die vorliegende Datenschutzerklärung jederzeit ändern. Diese Änderungen liegen im
                    alleinigen Ermessen von AMP IT. Massgebend ist die auf unserer Website und in unseren Anwendungen
                    veröffentlichte Fassung; sie trägt das am Anfang des vorliegenden Dokuments angegebene Datum.
                </Typography>
            </Box>
        </Box>
    );
};